import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './footer-social.scss.js';
import '../../../atoms/buttons/generic-button2.0/index.js';

class FooterSocial extends s {
    constructor() {
        super(...arguments);
        this.items = [];
    }
    static getValue(item, camelKey, pascalKey) {
        return String(item[camelKey] || item[pascalKey] || '');
    }
    static renderItem(item) {
        const link = FooterSocial.getValue(item, 'link', 'Link').trim();
        if (!link)
            return null;
        const image = FooterSocial.getValue(item, 'image', 'Image');
        const altText = FooterSocial.getValue(item, 'altText', 'AltText');
        const ariaLabelInput = FooterSocial.getValue(item, 'ariaLabel', 'AriaLabel');
        const ariaLabel = ariaLabelInput || altText || '';
        return $ `<li class="fs__item"><generic-button-updated class="fs__btn" .styleType="${'light'}" .color="${'cloud'}" .type="${'primary'}" .appearance="${'icon-circle'}" .customSvgUrl="${image}" .href="${link}" .target="${'_blank'}" .ariaList="${{ 'aria-label': ariaLabel }}" .isNoFollow="${true}"></generic-button-updated></li>`;
    }
    render() {
        return $ `<nav class="fs" role="navigation" aria-label="Social media"><ul class="fs__list">${this.items.map(item => FooterSocial.renderItem(item))}</ul></nav>`;
    }
}
FooterSocial.styles = css_248z;
__decorate([
    e({ type: Array })
], FooterSocial.prototype, "items", void 0);
customElements.define('footer-social', FooterSocial);

export { FooterSocial };
